import Utility from '../Utility/Utility';

let Utl = new Utility();
let language = Utl.getCookie("appLang");

const ownerFirst = ( language === "en" ? "First name" : "Nombre" );
const ownerLast = ( language === "en" ? "Last name" : "Apellido" );
const ownerAddr = ( language === "en" ? "Address" : "Dirección" );
const ownerCity = ( language === "en" ? "City" : "Ciudad" );
const ownerState = ( language === "en" ? "State" : "Estado" );
const ownerZip = ( language === "en" ? "Zip code" : "Código postal" );
const ownerPhone = ( language === "en" ? "Phone" : "Teléfono" );
const ownerEmail = ( language === "en" ? "Email address" : "Correo electrónico" );

export const AccountOwner = 
`
<div class='row form-group'>
    <div class='col-lg-2 text-end app-label-input'>
        <span class='me-2'><strong>*</strong></span> `+ownerFirst+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_first_name' id='cus_first_name' maxLength="16" class='form-control' required />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        <span class='me-2'><strong>*</strong></span> `+ownerLast+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_last_name' id='cus_last_name' maxLength="16" class='form-control' required />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        `+ownerAddr+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_address' id='cus_address' maxLength="64" class='form-control' />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        `+ownerCity+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_city' id='cus_city' maxLength="32" class='form-control' />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        `+ownerState+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <select name='cus_state' id='cus_state' class='form-control'></select>
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        `+ownerZip+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_zip' id='cus_zip' maxLength="10" class='form-control' />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        <span class='me-2'><strong>*</strong></span> `+ownerPhone+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_phone' id='cus_phone' class='form-control' placeholder="(999)-999-9999" maxLength="10" required />
    </div>
</div>

<div class='row form-group mt-2'>
    <div class='col-lg-2 text-end app-label-input'>
        `+ownerEmail+`
    </div>
    <div class='col-lg-10 text-start app-label-input'>
        <input type='text' name='cus_email' id='cus_email' maxLength="64" class='form-control' placeholder="account@domain.com" required />
    </div>
</div>
`;